import React, { useEffect, useState, CSSProperties } from 'react'
import RichTextEditor from 'react-rte'
import './style.less'

const toolbarConfig = {
  display: ['HISTORY_BUTTONS', 'INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS'],
  INLINE_STYLE_BUTTONS: [
    { label: 'Negrito', style: 'BOLD' },
    { label: 'Itálico', style: 'ITALIC' },
    { label: 'Sublinhado', style: 'UNDERLINE' }
  ],
  BLOCK_TYPE_BUTTONS: [
    { label: 'Lista simples', style: 'unordered-list-item' },
    { label: 'Lista numerada', style: 'ordered-list-item' },
    { label: 'Citação', style: 'blockquote' }
  ]
}

interface Props {
  onChange?: (e: string) => void;
  value: String;
  disabled: boolean;
}

const StripHtml = (html: string) => {
  let tmp = document.createElement("DIV");
  tmp.innerHTML = html.toString('html');
  return tmp.textContent || tmp.innerText || "";
}

const CountChar = (props: Props) => {
  const { disabled, className, html, maxLen=-1 } = props;
  let text = StripHtml(html);

  let color = 'black'
  if (maxLen > 0 && text.toString().length>maxLen){
    color = 'red'
  }
  const divStyle: CSSProperties = {
    color: color,
    float: 'right',
  }

  return !disabled &&
    <div style={divStyle} className={className}>
        {text.toString().length.toLocaleString('pt-BR') + (maxLen>0 ? " / "+maxLen.toLocaleString('pt-BR'):"")}
    </div>
}

const TextEditor = (props: Props) => {
  const { onChange, value, disabled = false, maxLen = -1 } = props
  const [innerValue, setInnerValue] = useState(RichTextEditor.createValueFromString(value, 'html'))

  useEffect(() => {
    const innerValueHtml = innerValue.toString('html')
    if (!innerValueHtml && value) {
      const newValue = RichTextEditor.createValueFromString(value, 'html')
      const html = newValue.toString('html')
      setInnerValue(newValue)
      onChange && onChange(html)
    }
  }, [innerValue, value, onChange])

  const onChangeValue = (v: any) => {
    setInnerValue(v)
    onChange && onChange(innerValue.toString('html'))
    return innerValue
  }

  const handledProps = ['value', 'onChange', 'toolbarConfig']
  const getUnhandledProps = props => {
    return Object.keys(props).reduce((acc, prop) => {
      if (!handledProps.includes(prop)) acc[prop] = props[prop]
      return acc
    }, {})
  }
  const newProps = getUnhandledProps(props)
  return <div {...newProps} className='text-editor'>
    <div>
      <RichTextEditor
        disabled={disabled}
        onChange={onChangeValue}
        toolbarConfig={toolbarConfig}
        value={innerValue}
        className='text-editor-container'
        editorClassName={ disabled ? 'edit-disabled' : 'edit-enabled' }
        name="richtext-editor"
      />
      <CountChar disabled={disabled} html={innerValue} className='counter' maxLen={maxLen} />
    </div>
  </div>
}

export default TextEditor
